import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { size } from "../../elements/font"

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  opacity: ${props => (props.isVisible ? "1" : "0")};
  visibility: ${props => (props.isVisible ? "visible" : "hidden")};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`

const ModalContainer = styled.div`
  background: linear-gradient(135deg, #1f2c5c 0%, #0f1419 100%);
  border-radius: 20px;
  padding: 60px 40px;
  max-width: 600px;
  width: 90%;
  max-height: 400px;
  position: relative;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  transform: ${props => (props.isVisible ? "scale(1)" : "scale(0.8)")};
  transition: transform 0.3s ease;

  @media only screen and (max-width: 768px) {
    padding: 40px 20px;
    max-width: 90%;
  }
`

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  svg {
    width: 20px;
    height: 20px;
    stroke: currentColor;
    stroke-width: 2;
  }
`

const Title = styled.h2`
  color: white;
  font-family: "Helvetica Neue", sans-serif;
  font-size: ${size.L};
  font-weight: 600;
  margin: 0 0 20px 0;
  letter-spacing: 0.02em;

  @media only screen and (max-width: 768px) {
    font-size: ${size.M};
  }
`

const Description = styled.p`
  color: white;
  font-family: "Helvetica Neue", sans-serif;
  font-size: ${size.S};
  line-height: normal;
  font-weight: 300;
  margin: 0 0 40px 0;
  opacity: 0.9;

  @media only screen and (max-width: 768px) {
    font-size: ${size.XS};
    margin: 0 0 30px 0;
  }
`

const CTAButton = styled.a`
  display: inline-block;
  background: transparent;
  color: white;
  font-family: "Helvetica Neue", sans-serif;
  font-size: ${size.XS};
  font-weight: 400;
  padding: 8px 48px;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid white;

  &:hover {
    background: white;
    color: #1f2c5c;
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }

  @media only screen and (max-width: 768px) {
    font-size: ${size.XS};
    padding: 12px 30px;
  }
`

const NovliniIOModal = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Vérifier si la modal a déjà été affichée dans cette session
    const hasShown = sessionStorage.getItem("novlini_modal_shown")

    if (true) {
      // Afficher la modal après 5 secondes
      const timer = setTimeout(() => {
        setIsVisible(true)
        sessionStorage.setItem("novlini_modal_shown", "true")
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [])

  const handleClose = () => {
    setIsVisible(false)
  }

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      handleClose()
    }
  }

  if (!isVisible) return null

  return (
    <ModalOverlay isVisible={isVisible} onClick={handleOverlayClick}>
      <ModalContainer isVisible={isVisible}>
        <CloseButton onClick={handleClose}>
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </CloseButton>

        <Title>Discover novlini.io</Title>
        <Description>
          We've just launched our new space dedicated to
          <br />
          Attio CRM and GTM strategies. Explore now.
        </Description>
        <CTAButton
          href="https://novlini.io"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here to visit novlini.io
        </CTAButton>
      </ModalContainer>
    </ModalOverlay>
  )
}

export default NovliniIOModal
